
const isSuitableSemver = (currentVersion, minimalVersion) => {
    const current = /(\d+)\.(\d+).(\d+)/.exec(currentVersion);
    const minimal = /(\d+)\.(\d+).(\d+)/.exec(minimalVersion);

    for (let i = 0; i < 3; i += 1) {
        if (current[i] > minimal[i]) {
            return true;
        }
        if (current[i] < minimal[i]) {
            return false;
        }
    }
    return true;
};

const getMobileAppVersion = (userAgentHeader) => {
    const searchResult =  /schoolbook-mobile\/((\d+)\.(\d+).(\d+))/.exec(userAgentHeader);
    return searchResult ? searchResult[1] : null;
};

module.exports = {
    isSuitableSemver,
    getMobileAppVersion,
};
